import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "input", "submit", "results", "overlay"]

  open() {
    if (this.hasModalTarget) {
      this.modalTarget.style.display = "flex"
      if (this.hasInputTarget) this.inputTarget.focus()
    }
  }

  close() {
    if (this.hasModalTarget) {
      this.modalTarget.style.display = "none"
      if (this.hasResultsTarget) this.resultsTarget.innerHTML = ""
      if (this.hasInputTarget) this.inputTarget.value = ""
    }
  }

  closeOnOverlay(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  async submit(event) {
    event.preventDefault()
    const urls = this.inputTarget.value.trim()
    if (!urls) return

    const btn = this.submitTarget
    btn.disabled = true
    btn.textContent = "Importing..."

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const res = await fetch("/sp/import", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token,
          "Accept": "application/json"
        },
        body: JSON.stringify({ urls: urls })
      })

      const data = await res.json()
      this.showResults(data.results || [])

      // Auto-refresh if any imports succeeded
      if (data.results?.some(r => r.status === "success")) {
        setTimeout(() => window.location.reload(), 2500)
      }
    } catch (e) {
      this.showResults([{ status: "error", message: "Network error: " + e.message }])
    } finally {
      btn.disabled = false
      btn.textContent = "Import"
    }
  }

  showResults(results) {
    if (!this.hasResultsTarget) return
    this.resultsTarget.innerHTML = results.map(r => {
      const icon = r.status === "success"
        ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>'
        : r.status === "duplicate"
        ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>'
        : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>'
      const cls = `pi-inline-result pi-inline-${r.status}`
      return `<div class="${cls}">${icon} <span>${this.escapeHtml(r.message)}</span></div>`
    }).join("")
  }

  escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
